import { render } from "./PartnerSedeDialog.vue?vue&type=template&id=6d15d561&scoped=true"
import script from "./PartnerSedeDialog.vue?vue&type=script&lang=js"
export * from "./PartnerSedeDialog.vue?vue&type=script&lang=js"

import "./PartnerSedeDialog.vue?vue&type=style&index=0&id=6d15d561&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-simba-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d15d561"]])

export default __exports__